import { CustomPointsCircleIcon } from "~/components/icons/CustomPointsCircleIcon";
import { PointsIcon } from "~/components/icons/PointsIcon";
import { POINTS_NAME } from "~/constants";

export function PointsLeaderboardIcon() {
	switch (POINTS_NAME) {
		case "tickets":
			return <CustomPointsCircleIcon />
		case "points":
		default:
			return <PointsIcon />
	}
}
